import styled from "styled-components";
import animate from "../../utils/animations";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  margin: 57px 0 0 60px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #e4e5e7;
  align-items: center;
  padding: 10px 0;

  ${mediaMaxWidth.tablet} {
    margin-left: 0;
  }
`;

export const ReviewsTableWrapper = styled.div`
  background-color: #fff;
  width: 960px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-shadow: 0 0 15px #dcdcdc;
  position: relative;
  ${animate("fadeIn", 0.3, 0.15)};

  ${mediaMaxWidth.mediumDesktop} {
    width: calc(100vw - 100px);
    margin: 0 auto;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);
    margin-bottom: 80px;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #d8d8d8;
  color: #000;
  font-weight: 600;
  padding: 5px 10px;

  ${mediaMaxWidth.phone} {
    font-size: 0.9em;
  }
`;

interface ITableHeaderItemProps {
  flex: number;
  justifyContent?: string;
  noMobile?: boolean;
}

export const TableHeaderItem = styled.div`
  display: flex;
  flex: ${(props: ITableHeaderItemProps) => props.flex};

  ${mediaMaxWidth.phone} {
    display: ${(props: ITableHeaderItemProps) => props.noMobile && "none"};
    justify-content: ${(props: IReviewLineItemProps) =>
      props.justifyContent && props.justifyContent};
  }
`;

export const TableBody = styled.div`
  padding: 10px 0;

  ${mediaMaxWidth.phone} {
    font-size: 0.85em;
    padding: 0;
  }
`;

export const NoReviews = styled.p`
  text-align: center;
  font-size: 1.1em;
  margin: 100px 0;

  ${mediaMaxWidth.phone} {
    font-size: 1em;
  }
`;

export const ReviewLineWrapper = styled.div`
  padding: 20px 10px;
  display: flex;
  align-items: center;

  ${mediaMaxWidth.phone} {
    padding: 20px 0px;
    margin: 0 10px;
  }
`;

interface IReviewLineItemProps {
  flex: number;
  justifyContent?: string;
  noMobile?: boolean;
}

export const ReviewLineItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${(props: IReviewLineItemProps) => props.flex};
  word-break: break-word;

  ${mediaMaxWidth.phone} {
    display: ${(props: IReviewLineItemProps) => props.noMobile && "none"};
    justify-content: ${(props: IReviewLineItemProps) =>
      props.justifyContent && props.justifyContent};
  }
`;

export const MobileInfo = styled.div`
  ${mediaMinWidth.phone} {
    display: none;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: none;
  border: none;
  font-weight: 700;
  font-size: 0.8em;
  padding: 0;

  ${mediaMaxWidth.phone} {
    margin-left: auto;
  }

  &:hover {
    color: #402680;
  }
`;
